<template>
  <div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item label="平台统计" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择平台">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="站点统计" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择站点">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="所属商家" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择商家">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="日统计" prop="status">
            <el-select v-model="queryForm.status" clearable placeholder="请选择统计">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="选择月份" prop="timeDate">
            <el-date-picker
                v-model="queryForm.timeDate"
                type="month"
                placeholder="选择月">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="6">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
            <el-button type="primary" size="small" plain
                       @click="importData()" icon="el-icon-refresh">
              导出</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-table :data="tableData" border default-expand-all stripe :header-cell-style="{'text-align':'center'}" style="width: 100%;margin-bottom: 20px;">
      <el-table-column prop="ID" label="序号" />
      <el-table-column prop="createTime" label="日期" />
      <el-table-column min-width="100%" prop="moneyTotail" label="待操作订单语音提醒" />
      <el-table-column min-width="100%" prop="moneyTotail" label="订单催评语音提醒" />
      <el-table-column min-width="100%" prop="remarks" label="短信" />
      <el-table-column min-width="100%" prop="moneyTotail" label="旺旺本品打标" />
      <el-table-column min-width="100%" prop="moneyTotail" label="旺旺降权查询" />
      <el-table-column min-width="100%" prop="remarks" label="淘口令解析" />
      <el-table-column min-width="100%" prop="moneyTotail" label="二维码加购" />
      <el-table-column min-width="100%" prop="moneyTotail" label="淘客订单查询" />
      <el-table-column min-width="100%" prop="remarks" label="物流" />
      <el-table-column min-width="100%" prop="remarks" label="合计" />
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>
  </div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
export default {
  name: "AddedServiceChart",
  mixins:[MixinCUD],
  data(){
    return {
      tableData:[],
      queryForm:{

      },
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
    }
  },
  methods: {
    // 自定义表头列宽
    flexColumnWidth(str) {
      let flexWidth = 0
      for (const char of str) {
        if ((char >= 'A' && char <= 'Z') || (char >= 'a' && char <= 'z')) {
          // 如果是英文字符，为字符分配8个单位宽度
          flexWidth += 8
        } else if (char >= '\u4e00' && char <= '\u9fa5') {
          // 如果是中文字符，为字符分配20个单位宽度
          flexWidth += 20
        } else {
          // 其他种类字符，为字符分配5个单位宽度
          flexWidth += 5
        }
      }
      if (flexWidth < 50) {
        // 设置最小宽度
        flexWidth = 200
      }
      if (flexWidth > 250) {
        // 设置最大宽度
        flexWidth = 250
      }
      return flexWidth + 'px'
    },
  }
}
</script>

<style scoped>
.el-form {
  margin-top: 20px;
}
</style>
